<script setup>
import {inject} from "vue";
import {trackerAccess} from "@/helpers/string";

const tracker = inject('tracker');
const openAccessSettings = inject('openAccessSettings');
</script>

<template>
    <div>
        <h5 class="heading5 heading5--secondary mt-4 mb-2">Ecosystem Sharing</h5>
        <div class="shared-ecosystem-label">
            <p class="modal-text"> {{ trackerAccess(tracker) }}
                <a
                    v-if="tracker.user_permissions.includes('tracker-add-ecosystem')"
                    class="heading-edit"
                    @click="openAccessSettings"
                />
            </p>
        </div>
    </div>
</template>

<style scoped>

</style>
